import { Link } from "react-router-dom";

export function PublicHeader() {
  return (
    <header className="bg-white border-b border-[var(--color-ink)] sticky top-0 z-10">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 py-4 flex justify-between items-center">
        <Link to="/" className="flex gap-2 items-center">
          <img
            src="/logo-gim94.png"
            alt="Гимназия №94"
            className="w-7 h-7 object-contain"
          />
          <span className="text-xs font-bold uppercase tracking-[0.05em] text-[var(--color-ink)]">
            Гимназия №94 · Екатеринбург
          </span>
        </Link>
        <nav className="flex gap-5 text-xs">
          <Link
            to="/login"
            className="text-[var(--color-ink)] no-underline border-b border-transparent hover:border-[var(--color-ink)] pb-[2px]"
          >
            Войти
          </Link>
          <Link
            to="/register"
            className="text-[var(--color-ink)] no-underline border-b border-transparent hover:border-[var(--color-ink)] pb-[2px]"
          >
            Регистрация
          </Link>
        </nav>
      </div>
    </header>
  );
}
